module.exports = __webpack_public_path__ + "static/img/logo_jiaxiao.6e5473c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_jiaxiao.png
// module id = DgfZ
// module chunks = 1